module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71836/img/landing-page-zero.png"